import { Field, Form, Group, Subform } from '@icure/form/components/model'

export const getAllFields = (form: Form): Field[] => {
  const getAllFieldsInternal = (fieldsOrGroups: (Field | Group | Subform)[]): Field[] => {
    return fieldsOrGroups.flatMap((f) => (f.clazz === 'field' ? [f] : f.clazz === 'group' ? getAllFieldsInternal(f.fields ?? []) : []))
  }
  return form.sections.flatMap((s) => getAllFieldsInternal(s.fields ?? []))
}

export const getFields = (form: Form, label: string) => {
  const getFieldsInternal = (fieldsOrGroups: (Field | Group | Subform)[], label: string): Field[] => {
    return fieldsOrGroups.flatMap((f) => (f.clazz === 'field' ? (f.field === label ? [f] : []) : f.clazz === 'group' ? getFieldsInternal(f.fields ?? [], label) : []))
  }
  return form.sections.flatMap((s) => getFieldsInternal(s.fields ?? [], label))
}

export const getOptions = (form: Form, label: string) => {
  const getOptionsInternal = (fieldsOrGroups: (Field | Group | Subform)[], label: string): [string, string][] => {
    return fieldsOrGroups.flatMap((f) =>
      f.clazz === 'field' ? (f.options?.[label] ? [[label, f.options[label] as string]] : []) : f.clazz === 'group' ? getOptionsInternal(f.fields ?? [], label) : [],
    )
  }
  return form.sections.flatMap((s) => getOptionsInternal(s.fields ?? [], label))
}
